// client/src/lib/domains.js
//
// Hostnames that belong to the platform itself (default VidyalayHelp branding), as
// opposed to a white-label vendor / school domain. Pure and dependency-free so the
// Edge middleware can import it. Mirrors server/config/domains.js.

export const PRODUCTION_SITE_URL = 'https://vidyalayhelp.com';

const siteHost = (() => {
  try {
    return new URL(process.env.NEXT_PUBLIC_SITE_URL || PRODUCTION_SITE_URL).hostname.toLowerCase();
  } catch {
    return 'vidyalayhelp.com';
  }
})();

// The official domain (+ www), the older desync.in host, and local development.
export const PLATFORM_HOSTS = [
  siteHost,
  `www.${siteHost.replace(/^www\./, '')}`,
  'vidyalayhelp.com',
  'www.vidyalayhelp.com',
  'vidyalayhelp.desync.in',
  'www.vidyalayhelp.desync.in',
  'localhost',
  '127.0.0.1',
];

export const isPlatformHost = (host = '') => {
  const h = String(host).toLowerCase().split(':')[0];
  return PLATFORM_HOSTS.includes(h) || h.endsWith('.vercel.app');
};
